export default __webpack_public_path__ + "9520f0b7d6f17f663837c0d0decc0e08.png";